import { handleActions } from 'redux-actions';
import { RootState, UserState } from '../../../types';
import userActions from './actions';
import { Transaction } from 'helpers/utils';

type PaginatedList = {
  [key: number]: any;
};

export const pushToPaginatedList = (
  linkedList: PaginatedList = {},
  { page, data }: { page?: number; data?: any[] } = {}
): PaginatedList => {
  if (!page || page < 1) {
    return linkedList;
  }
  if (page === 1) {
    return {
      1: data
    };
  }
  let currentPage = 1;
  const newLinkedList: PaginatedList = {};
  while (currentPage < page && linkedList[currentPage]) {
    newLinkedList[currentPage] = linkedList[currentPage];
    currentPage += 1;
  }
  if (currentPage === page) {
    newLinkedList[page] = data;
  }
  return newLinkedList;
};

export default handleActions<UserState, any>(
  {
    [userActions.fetchUserActivitiesSuccess.toString()]: (state, action) => ({
      ...state,
      activities: action.payload
    }),
    [userActions.fetchUserTodosSuccess.toString()]: (state, action) => ({
      ...state,
      todos: action.payload
    }),
    [userActions.fetchUserTransactionsSuccess.toString()]: (
      state,
      { payload: { wallet, page, transactions } }
    ) => ({
      ...state,
      transactions: {
        ...state.transactions,
        [wallet]: pushToPaginatedList(state.transactions[wallet], {
          page,
          data: transactions
        })
      }
    })
  },
  {
    activities: null,
    todos: null,
    transactions: {}
  }
);

export const getUserActivities = (state: RootState) =>
  state.app.user.activities;
export const getUserTodos = (state: RootState) => state.app.user.todos;
export const createUserTransactionsSelector = (wallet: string) => (
  state: RootState
) => {
  const transactionsByPage = state.app.user.transactions[wallet] || {};
  const transactions: Transaction[] = [];
  Object.keys(transactionsByPage).forEach(key => {
    transactions.push(...transactionsByPage[key]);
  });
  return transactions;
};
